export default values => ({
  payday: values.payday || 1
});
